// extracted by mini-css-extract-plugin
export default {"nav-link":"MainNavigation_nav-link__-ipV0","nav-link--active":"MainNavigation_nav-link--active__cY0Lo"};